module.exports = __webpack_public_path__ + "assets/img/step8.f4e5acc1.jpg";